// Angular Modules
import { Injectable, signal } from '@angular/core';

export interface ITheme {
  text: string;
  bg: string;
}


@Injectable({ providedIn: 'root' })
export class ThemeService {


  darkTheme: ITheme = {
    text: 'light',
    bg: 'dark',
  };
  lightTheme: ITheme = {
    text: 'dark',
    bg: 'light',
  };

  themeState = signal<ITheme>(this.lightTheme);

  get currentTheme() {
    return this.themeState().bg == this.lightTheme.bg
  }

  toggleTheme() {
    this.themeState().bg == this.darkTheme.bg
      ? this.themeState.set(this.lightTheme)
      : this.themeState.set(this.darkTheme);
  }

}
